import { render, staticRenderFns } from "./djdd_add.vue?vue&type=template&id=b24469e0&"
import script from "./djdd_add.vue?vue&type=script&lang=js&"
export * from "./djdd_add.vue?vue&type=script&lang=js&"
import style0 from "./djdd_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports